
import { Component, Vue } from 'vue-property-decorator';
import { db } from '@/plugins/firebase';

@Component({})
export default class DictEntries extends Vue {
  events: any = [];

  showLikers(likerUids: Array<string>) {
    console.log(likerUids);
  }
  async created() {
    const snapshot = await db
      .collection('timeline')
      .limit(50)
      .orderBy('timestamp', 'desc')
      .get();
    snapshot.forEach((doc) => {
      const data = doc.data();
      data.id = doc.id;
      this.events.push(data);
    });
  }
}
